<script>
    import { list } from "../list.json";
    import { getCoverImgUrl } from "../dal/business-dal";
    import FaMapMarker from "svelte-icons/fa/FaMapMarker.svelte";
    import BagIcon from "./icons/BagIcon.svelte";

</script>

<div class="container">
    <h1>המקומות שלנו</h1>
    {#each list as business}
        <a href="#/b/{business.code}">
            <div class="thumb">
                <img src={getCoverImgUrl(business.code)} alt="" />
                <div class="details">
                    <h2>{business.title}</h2>
                    <div class="circles">
                        <div />
                        <div />
                        <div />
                    </div>
                    <div class="bottom">
                        <i><FaMapMarker /></i>
                        {business.address}
                        <i class="bagIcon">
                            <BagIcon color="#75afff" />
                        </i>
                        איסוף עצמי
                    </div>
                </div>
            </div>
        </a>
    {/each}
</div>

<style>
    .bottom {
        position: absolute;
        bottom: 10px;
        right: 10px;
        display: flex;
        align-items: baseline;
        font-size: 15px;
    }

    i {
        width: 12px;
        display: block;
        color: #75afff;
        margin-left: 10px;
    }

    .bagIcon {
        margin-right: 20px;
    }

    .circles {
        display: flex;
        gap: 10px;
        margin-top: 10px;
        margin-right: 10px;
    }

    .circles > div {
        width: 7px;
        height: 7px;
        border-radius: 100px;
        background: #474747;
    }

    .container {
        width: 100%;
        display: flex;
        justify-content: center;
        gap: 54px;
        margin-top: 40px;
        margin-bottom: 40px;
        flex-wrap: wrap;
        padding: 20px;
        box-sizing: border-box;
    }

    .thumb {
        position: relative;
        width: 350px;
        height: 350px;
        background: white;
        border: 1px solid hsl(0deg 0% 92%);
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 8px 20px -20px;
    }

    .thumb > img {
        width: 100%;
        height: 200px;
        object-fit: cover;
    }

    .details {
        direction: rtl;
        font-family: "Rubik";
        padding: 20px;
    }

    h1 {
        text-align: right;
        width: 100%;
        padding-right: 37px;
        font-size: 30px;
        font-family: "Varela round";
        color: #474747eb;
        margin: 10px;
        font-weight: 100;
    }
    h2 {
        font-weight: 100;
        font-size: 24px;
        margin: 0;
    }

    @media (max-width: 400px) {
        .thumb {
            width: 100%;
            border-radius: 0;
        }

        a {
            width: 100%;
        }

        .container {
            padding: 10px;
        }
    }

</style>
